import React, { Component } from 'react';
import carouselImg from "../assets/img/carousel-1.jpg";
import carouselIm from "../assets/img/carousel-2.jpg";

export class Faqs extends Component {
    static displayName = Faqs.name;

  render() {
    return (
        <div>

            {/*faqs navbar starts here*/}
            <div class="container-fluid position-relative p-0">
                <div class="container-fluid bg-primary py-5 bg-header">
                    <div class="row py-5">
                        <div class="col-12 pt-lg-5 mt-lg-5 text-center animated zoomIn">
                            <h3 class="text-capitalize text-white animated zoomIn">faqs</h3>
                            <a class="h5 text-capitalize text-white">home</a>
                            <i class="bi bi-chevron-right text-white px-2"></i>
                            <a class="h5 text-capitalize text-white">faqs</a>
                        </div>
                    </div>
                </div>
            </div>
            {/*faqs navbar ends here*/}

            {/*faqs section starts here*/}
            <div class="container my-5">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title faqs-head text-capitalize">Frequently Asked Questions (FAQs)</h3>
                        </div>

                        <div class="card-body">
                            <div class="accordion" id="accordionExample">

                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <button class="accordion-button bg-light py-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
                                            Where are you located?
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            Jewstechs Solutions Ltd is based in Nairobi, Kenya. We provide on-site ICT services throughout the country and also offer remote consultation and technical support where applicable.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                        <button class="accordion-button collapsed bg-light py-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
                                            What services do you offer?
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            We specialize in computer networking, IT infrastructure management, virtualization, enterprise storage, backup and replication, CCTV surveillance, access control systems, biometric solutions, and professional ICT consultation for businesses and organizations.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingThree">
                                        <button class="accordion-button collapsed bg-light py-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                                            Do you provide maintenance and support services?
                                        </button>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            Yes. We offer preventive maintenance, infrastructure monitoring, system upgrades, troubleshooting, and technical support for networking equipment, servers, storage systems, CCTV installations, access control systems, and other ICT infrastructure.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingFour">
                                        <button class="accordion-button collapsed bg-light py-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">
                                            How much do your services cost?
                                        </button>
                                    </h2>
                                    <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            Our pricing depends on the project scope, equipment requirements, installation complexity, and support services required. We provide detailed quotations after assessing your business needs.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingFive">
                                        <button class="accordion-button collapsed bg-light py-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">
                                            Do you support existing IT infrastructure?
                                        </button>
                                    </h2>
                                    <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            Absolutely. We support existing IT environments by optimizing network performance, managing virtualization platforms, maintaining enterprise storage, implementing backup and replication solutions, and enhancing infrastructure security.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingSix">
                                        <button class="accordion-button collapsed bg-light py-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix">
                                            Are there any hidden costs?
                                        </button>
                                    </h2>
                                    <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            No. We believe in transparent pricing. All project costs, equipment, installation charges, and support services are clearly outlined in our quotations before work begins.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingSeven">
                                        <button class="accordion-button collapsed bg-light py-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven">
                                            How can I request a consultation or quotation?
                                        </button>
                                    </h2>
                                    <div id="collapseSeven" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            You can request a consultation or quotation through our website's contact form, email, or phone. Our team will discuss your requirements, assess your infrastructure needs, and provide a customized solution and competitive quotation.
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*faqs section ends here*/}

      </div>
    );
  }
}
